/**
 * Created by Languagenut on 19/06/2019.
 */

import React  from 'react';
import {Alert , Spinner , Col , Row , ButtonToolbar , Modal , Button  , Navbar , Nav , NavDropdown} from 'react-bootstrap'


import BootstrapTable from 'react-bootstrap-table-next';
import FieldGroup from '../FieldGroup.js';
import Translation from '../../store/internationalization-store.js'
import ClassesService from '../../services/classes-service.js';

export default class TextPopup extends React.Component {

    constructor(props) {
        super();
        this.props = props;

        console.log(this.props);

        this.state = {
            name: '',
            typing: false,
            disable:true,
            typingTimeout: 0
        };
    }

    componentWillReceiveProps(props){
        this.props = props;
        this.state = {
            value:this.props.value || ""
        };
    }

    makenew(){
        this.setState({
            thinking:true,
        })
        ClassesService.addStudents([{'state':'new' , name:this.state.name}], this.props.classID).then(function(response){
            ClassesService.getStudents(this.props.classID)
            this.props.onHide();
        }.bind(this));

    }


    useExsiting(){
        let existing = this.state.existingStudents || [];


        existing[0]['state'] = 'add';
        this.setState({
            thinking:true,
        })
        ClassesService.addStudents( [existing[0]] , this.props.classID).then(function(response){
            ClassesService.getStudents(this.props.classID)
            this.props.onHide();
        }.bind(this));
    }

    onChange(event){
        const self = this;

        if (self.state.typingTimeout) {
            clearTimeout(self.state.typingTimeout);
        }

        self.setState({
            name: event.target.value,
            typing: false,
            disable:true,
            typingTimeout: setTimeout(function () {
                self.sendToParent(self.state.name);
            }, 500)
        });
    }

    sendToParent(name){

        this.setState({
            thinking:true,
        })

        ClassesService.doesStudentsExist([name] , this.props.classID).then(function(response){

            if(response.existingStudents)
            {
                if(response.existingStudents.length > 0)
                {

                    this.setState({
                        existingStudents:response.existingStudents,
                        exising:true,
                        new:false,
                        disable:false,
                        thinking:false,
                    })

                    return;
                }
            }

            this.setState({
                new:true,
                exising:false,
                disable:false,
                existingStudents:[],
                thinking:false,
            })
        }.bind(this))

    }

    render() {

        let Buttons = [];
        let error = null;
        if(this.state.exising)
        {
            error = <Alert key={'warning'} variant={'danger'}>
                {Translation.get(12665 , 'A student with this name already exists. Is this a new or existing student you wish to add to this class?')}
            </Alert>
            Buttons = <Modal.Footer>
                {[<Button disabled={this.state.disabled} onClick={this.useExsiting.bind(this)}>{Translation.get(12666 , 'Use existing')}</Button> , <Button disabled={this.state.disabled} onClick={this.makenew.bind(this)}>{Translation.get(12765 , 'Create new')}</Button>]}</Modal.Footer>
        }

        if(this.state.new)
        {
            Buttons = <Modal.Footer>{[<Button disabled={this.state.disabled} onClick={this.makenew.bind(this)}>{Translation.get(12667 , 'Create')}</Button>]}</Modal.Footer>
        }

        if(this.state.thinking)
        {
            Buttons = <Modal.Footer><Spinner animation="border" size="sm" /></Modal.Footer>
        }

        if( !this.state.name || String(this.state.name.length) <= 2)
        {
            Buttons = null;
        }


        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {Translation.get(435 , 'Add a Student')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="strong">
                        <Col md={12}>
                            <FieldGroup value={this.state.name} onChange={this.onChange.bind(this)} className="strong" as="input" label={Translation.get(827 , 'Student Name')}  type="input" autofocus="true"/>
                        </Col>
                        <br/>
                        <Col md={12}>
                            {error}
                         </Col>
                    </Row>
                </Modal.Body>
                {Buttons}
            </Modal>
        );
    }
}